import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaycabshirdi() {



    const cardData = {





keyword: "One Way Cab Shirdi",
headingDescription: "Sai Shirdi Cab offers convenient one way cab service in Shirdi for travelers who need reliable transportation to their destination without booking a return journey. One way taxi booking is a practical option for passengers traveling from Shirdi to nearby cities, pilgrimage destinations, airports, railway stations, business locations, and other outstation places. The service is suitable for families, couples, devotees, senior citizens, business travelers, and small groups looking for private and comfortable transportation. Customers can select a suitable vehicle according to their passenger count and luggage requirements, with planned pickup and direct drop arrangements. Sai Shirdi Cab provides one way travel options from Shirdi with experienced drivers and flexible scheduling, making it easier to plan intercity journeys without paying for an unnecessary return trip. Whether the requirement is for a short outstation transfer or a longer journey across Maharashtra and nearby states, the cab can be arranged according to the passenger's route and preferred travel time.",

topPlaces: [
{
title: "Pune",
description: "Pune is a popular one way travel destination from Shirdi for business trips, family visits, educational travel, and personal journeys. Sai Shirdi Cab can arrange a private one way cab for passengers who only need transportation from Shirdi to Pune without requiring a return booking. The journey can be planned according to the preferred pickup time, passenger count, luggage, and exact drop location."
},
{
title: "Nashik",
description: "Nashik is a convenient outstation destination from Shirdi for pilgrimage, business, family travel, and sightseeing. Travelers who do not need a return taxi can choose one way cab service from Sai Shirdi Cab for a direct journey to Nashik. The booking can be organized around the passenger's schedule with a suitable vehicle and convenient pickup arrangement."
},
{
title: "Aurangabad",
description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is a useful one way route from Shirdi for travelers visiting historical, cultural, and business destinations. Sai Shirdi Cab provides private one way transportation for passengers who want to continue their journey from Shirdi without returning in the same cab. The service can also be useful for travelers planning onward trips to nearby heritage attractions."
},
{
title: "Mumbai",
description: "Mumbai is an important long-distance destination for passengers traveling from Shirdi for business, family visits, medical appointments, events, or onward travel. A one way cab from Sai Shirdi Cab provides direct private transportation to Mumbai without requiring passengers to pay for an unused return journey. Pickup and drop details can be planned according to the passenger's preferred schedule and destination."
},
{
title: "Bhimashankar",
description: "Bhimashankar is a suitable one way pilgrimage route for devotees and families traveling from Shirdi. Sai Shirdi Cab can arrange a private cab for passengers who need direct transportation to Bhimashankar and plan to make their own return arrangements. The journey can be customized according to the travel schedule, passenger requirements, and preferred pickup location in Shirdi."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is an important religious destination that can be reached conveniently through one way cab booking from Shirdi. Devotees and families can choose Sai Shirdi Cab when they need a direct transfer without reserving the vehicle for the return journey. The cab can be scheduled around the preferred departure time and destination requirements for a smooth outstation trip."
},
{
title: "Goa",
description: "Goa is a long-distance option for travelers departing from Shirdi for holidays, family vacations, celebrations, or onward travel. One way cab service from Sai Shirdi Cab is useful for passengers who want private transportation to Goa without keeping the same vehicle for the return trip. The journey can be arranged with a suitable vehicle based on passenger count, luggage, and travel schedule."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is a practical one way pilgrimage destination for travelers starting their journey from Shirdi. Sai Shirdi Cab can arrange direct private transportation for devotees and families who need a one way transfer and plan separate transportation afterward. The booking can be coordinated around temple visit plans, pickup timing, and the passenger's preferred drop location."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a suitable leisure destination for travelers looking for a one way cab from Shirdi for a family holiday, weekend trip, or extended Maharashtra tour. Sai Shirdi Cab can arrange private transportation directly to the hill station without requiring a return booking. This gives travelers greater flexibility when their onward travel plans are different from their departure route."
},
{
title: "Saputara",
description: "Saputara can be selected for a one way journey from Shirdi by families, friends, and leisure travelers planning an onward holiday. Sai Shirdi Cab provides private cab arrangements for passengers who only need transportation to the destination and do not require the same cab for their return. The trip can be scheduled according to the preferred departure time and travel requirements."
}
]
,








"services": [
{
"name": "One Way Cab Shirdi",
"description": "Sai Shirdi Cabs offers convenient one way cab services from Shirdi for travelers who need a comfortable ride to their destination without booking a return journey. Our one way cabs are suitable for personal trips, family travel, business journeys, and outstation transfers."
},
{
"name": "One Way Taxi Shirdi",
"description": "Book a reliable one way taxi in Shirdi for hassle-free travel to nearby cities and long-distance destinations. Sai Shirdi Cabs provides comfortable taxi options with flexible pickup arrangements for devotees, tourists, and local travelers."
},
{
"name": "one way cab service in Shirdi",
"description": "Our one way cab service in Shirdi is designed for passengers looking for convenient point-to-point transportation at practical fares. From airport transfers to intercity travel, Sai Shirdi Cabs makes one way journeys comfortable and easy to arrange."
},
{
"name": "one way taxi service in Shirdi",
"description": "Sai Shirdi Cabs provides a dependable one way taxi service in Shirdi for travelers heading to cities, airports, temples, and other outstation destinations. Enjoy a comfortable ride without the need to pay for an unnecessary return trip."
},
{
"name": "Shirdi one way cab booking",
"description": "Make your travel plans simple with Shirdi one way cab booking from Sai Shirdi Cabs. Select a suitable vehicle and arrange a convenient pickup for your destination, making the journey easier for individuals, families, and groups."
},
{
"name": "Shirdi one way taxi booking",
"description": "Shirdi one way taxi booking is a convenient choice for passengers traveling to another city without requiring a return cab. Sai Shirdi Cabs offers comfortable taxi options for planned outstation journeys with convenient pickup and drop arrangements."
},
{
"name": "Shirdi one way outstation cab",
"description": "Choose a Shirdi one way outstation cab for comfortable travel from Shirdi to destinations across Maharashtra and nearby states. Sai Shirdi Cabs provides suitable vehicles for solo passengers, families, and groups traveling on flexible schedules."
},
{
"name": "Shirdi one way outstation taxi",
"description": "Sai Shirdi Cabs offers one way outstation taxis from Shirdi for convenient long-distance transportation. Whether traveling for business, pilgrimage, family commitments, or personal work, passengers can enjoy a dedicated taxi ride to their destination."
},
{
"name": "Shirdi to Mumbai one way cab",
"description": "Book a Shirdi to Mumbai one way cab for a comfortable intercity journey without arranging a return vehicle. Sai Shirdi Cabs provides convenient cab options for travelers heading from Shirdi to Mumbai for business, airport connections, family visits, and other purposes."
},
{
"name": "Shirdi to Pune one way cab",
"description": "Travel comfortably from Shirdi to Pune with a dedicated one way cab from Sai Shirdi Cabs. This service is suitable for devotees, students, professionals, families, and travelers who need a direct and convenient ride to Pune."
},
{
"name": "Shirdi to Nashik one way cab",
"description": "Sai Shirdi Cabs provides comfortable Shirdi to Nashik one way cab services for passengers looking for direct outstation transportation. Enjoy a convenient journey between the two cities without the additional cost and planning associated with a return booking."
},
{
"name": "Shirdi to Aurangabad one way cab",
"description": "Book a Shirdi to Aurangabad one way cab for a smooth and convenient journey to your destination. Sai Shirdi Cabs offers practical vehicle choices for families, individuals, and groups traveling from Shirdi to Aurangabad for business, tourism, or personal requirements."
},
{
"name": "Shirdi to Goa one way cab",
"description": "Plan your long-distance journey with a Shirdi to Goa one way cab from Sai Shirdi Cabs. Our outstation cab service provides a comfortable travel option for passengers heading to Goa without needing to reserve the same vehicle for the return journey."
},
{
"name": "Shirdi to Indore one way cab",
"description": "Sai Shirdi Cabs offers Shirdi to Indore one way cab services for travelers looking for direct and comfortable transportation between the two cities. Suitable for families, business travelers, and individual passengers, the service can be arranged according to your travel schedule."
},
{
"name": "Shirdi to Pandharpur one way cab",
"description": "Travel from Shirdi to Pandharpur conveniently with a dedicated one way cab from Sai Shirdi Cabs. This service is useful for pilgrims and families who want a comfortable direct journey without the requirement of booking a round trip."
},
{
"name": "Shirdi to Trimbakeshwar one way cab",
"description": "Book a Shirdi to Trimbakeshwar one way cab for a convenient pilgrimage journey to Trimbakeshwar. Sai Shirdi Cabs provides comfortable outstation transportation for devotees and travelers who prefer a direct cab from Shirdi to their destination."
},
{
"name": "Shirdi to Bhimashankar one way cab",
"description": "Sai Shirdi Cabs provides a convenient Shirdi to Bhimashankar one way cab service for travelers planning a temple or pilgrimage trip. Enjoy a dedicated ride with suitable cab options for individuals, families, and small groups."
},
{
"name": "Shirdi one way Ertiga Cab",
"description": "The Shirdi one way Ertiga Cab is a practical choice for families and groups seeking extra seating space and a comfortable outstation journey. Sai Shirdi Cabs offers Ertiga vehicles for one way travel to cities, pilgrimage destinations, airports, and other locations."
},
{
"name": "Shirdi one way Innova Cab",
"description": "Book a Shirdi one way Innova Cab when you need a spacious and comfortable vehicle for an outstation journey. Sai Shirdi Cabs provides Innova options for families and groups who want a relaxed ride from Shirdi to their preferred destination."
},
{
"name": "affordable one way cab from Shirdi",
"description": "Sai Shirdi Cabs offers affordable one way cab options from Shirdi for travelers who want comfortable transportation without paying for an unused return journey. Choose from suitable vehicle options for local transfers, airport travel, and long-distance outstation routes."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides one way cab and taxi services from Shirdi to major cities, airports, pilgrimage destinations, and outstation locations. With options including sedan, Ertiga, and Innova cabs, travelers can arrange comfortable point-to-point transportation for different journey requirements."
}
],
"tableData": [
["One Way Cab Shirdi", "One Way Taxi Shirdi"],
["one way cab service in Shirdi", "one way taxi service in Shirdi"],
["Shirdi one way cab booking", "Shirdi one way taxi booking"],
["Shirdi one way outstation cab", "Shirdi one way outstation taxi"],
["Shirdi to Mumbai one way cab", "Shirdi to Pune one way cab"],
["Shirdi to Nashik one way cab", "Shirdi to Aurangabad one way cab"],
["Shirdi to Goa one way cab", "Shirdi to Indore one way cab"],
["Shirdi to Pandharpur one way cab", "Shirdi to Trimbakeshwar one way cab"],
["Shirdi to Bhimashankar one way cab", "Shirdi one way Ertiga Cab"],
["Shirdi one way Innova Cab", "affordable one way cab from Shirdi"],
["Sai Shirdi Cabs", "One Way Cab Shirdi"]
]
,





whychoose: [  
 
    {   
 
        WhyChooseheading: "One Way Cab Shirdi for Convenient Outstation Travel",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides One Way Cab Shirdi services for devotees, families, tourists, business travellers, and passengers who need direct transportation from Shirdi to their destination. A private one-way cab can be arranged according to your pickup location, travel date, preferred departure time, passenger count, luggage requirements, and selected destination."   
 
    },   
 
    {   
 
        WhyChooseheading: "Private One Way Taxi from Shirdi",   
 
        WhyChoosedescription: "Travellers can book a private one-way taxi from Shirdi for direct outstation transportation without requiring a return journey. Sai Shirdi Cabs can coordinate the trip according to your selected destination, pickup point, travel schedule, number of passengers, and luggage details for a practical one-way travel arrangement."   
 
    },   
 
    {   
 
        WhyChooseheading: "One Way Cab Service for Sai Baba Devotees",   
 
        WhyChoosedescription: "Devotees completing Sai Baba Darshan in Shirdi can arrange a one-way cab for their onward journey to another city. The taxi can be planned from your hotel, accommodation, or another suitable pickup location in Shirdi according to your departure time, destination, passenger requirements, and overall pilgrimage schedule."   
 
    },   
 
    {   
 
        WhyChooseheading: "One Way Cab from Shirdi to Major Cities",   
 
        WhyChoosedescription: "Passengers travelling from Shirdi to cities such as Pune, Mumbai, Nashik, Aurangabad, Ahmednagar, or other destinations can discuss one-way cab requirements with Sai Shirdi Cabs. The service can be arranged around your preferred route, travel date, pickup location, passenger count, luggage, and destination requirements."   
 
    },   
 
    {   
 
        WhyChooseheading: "One Way Taxi for Families and Small Groups",   
 
        WhyChoosedescription: "Families and small groups can choose a private one-way taxi when travelling together from Shirdi with luggage. Sharing the number of passengers and luggage requirements during booking helps in planning a suitable vehicle arrangement and makes it easier for the entire group to travel together towards the selected destination."   
 
    },   
 
    {   
 
        WhyChooseheading: "One Way Cab from Shirdi Hotel Pickup",   
 
        WhyChoosedescription: "Passengers can discuss pickup from their hotel, accommodation, or another convenient location in Shirdi while booking a one-way cab. This is useful for travellers who complete their temple visit or local sightseeing and want to continue directly to their next destination without arranging separate local transportation."   
 
    },   
 
    {   
 
        WhyChooseheading: "One Way Cab with Flexible Travel Planning",   
 
        WhyChoosedescription: "Sai Shirdi Cabs can plan one-way transportation according to the passenger's travel requirements, including destination, journey date, preferred departure time, passenger count, luggage details, and pickup location. Providing complete trip information helps in coordinating the cab service around your planned outstation journey."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book One Way Cab Shirdi with Sai Shirdi Cabs",   
 
        WhyChoosedescription: "To book a One Way Cab Shirdi, contact Sai Shirdi Cabs with your pickup location, destination, travel date, preferred departure time, passenger count, luggage information, and other requirements. Complete journey details help in arranging private one-way transportation according to your planned travel schedule."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I book a One Way Cab from Shirdi?", 
 
answer: "Yes, Sai Shirdi Cabs provides private one-way cab services from Shirdi for devotees, families, tourists, business travellers, and passengers travelling to other destinations." 
 
}, 
 
{ 
 
question: "What is a One Way Cab in Shirdi?", 
 
answer: "A one-way cab is a private taxi arrangement for travelling from Shirdi to your selected destination without requiring the same vehicle to return you to Shirdi." 
 
}, 
 
{ 
 
question: "Can I book a one-way taxi after Sai Baba Darshan?", 
 
answer: "Yes, devotees can arrange a one-way taxi from their hotel or another suitable pickup location in Shirdi after completing Sai Baba Darshan and their planned pilgrimage activities." 
 
}, 
 
{ 
 
question: "Which destinations can I travel to by One Way Cab from Shirdi?", 
 
answer: "You can discuss one-way cab transportation from Shirdi to destinations such as Pune, Mumbai, Nashik, Ahmednagar, Aurangabad, and other cities according to your travel requirements." 
 
}, 
 
{ 
 
question: "Can families book a One Way Cab in Shirdi?", 
 
answer: "Yes, families can book a private one-way cab from Shirdi and provide their passenger count, luggage details, destination, and preferred travel schedule while making the booking." 
 
}, 
 
{ 
 
question: "Can I get hotel pickup for a One Way Cab in Shirdi?", 
 
answer: "Yes, pickup from your hotel, accommodation, or another suitable location in Shirdi can be discussed while booking the one-way cab based on your travel details." 
 
}, 
 
{ 
 
question: "Can I travel with luggage in a Shirdi One Way Cab?", 
 
answer: "Yes, passengers can travel with luggage, and it is recommended to provide the luggage details along with the passenger count so the transportation arrangement can be planned according to your requirements." 
 
}, 
 
{ 
 
question: "Is One Way Cab service suitable for small groups?", 
 
answer: "Yes, small groups can arrange private one-way transportation from Shirdi according to the number of passengers, luggage requirements, destination, and preferred vehicle arrangement." 
 
}, 
 
{ 
 
question: "Can I choose my departure time for a One Way Cab from Shirdi?", 
 
answer: "Yes, you can provide your preferred departure time along with your travel date, pickup location, destination, passenger count, and other requirements while booking the one-way cab." 
 
}, 
 
{ 
 
question: "How can I book a One Way Cab Shirdi?", 
 
answer: "You can contact Sai Shirdi Cabs with your Shirdi pickup location, destination, travel date, preferred departure time, passenger count, luggage information, and other travel requirements to arrange your one-way cab booking." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Rohan Jadhav", 
 
feedback: "We booked a One Way Cab from Shirdi after completing our Sai Baba Darshan. The private taxi was convenient for our family, and we could travel together with our luggage directly towards our next destination.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Sneha Patil", 
 
feedback: "Sai Shirdi Cabs arranged our one-way cab from Shirdi for our onward journey. We provided our pickup location, destination, passenger details, and travel timing during booking, which made the transportation planning simple.", 
 
rating: 5 
 
} 
 
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/one-way-cab-shirdi.webp",
  "description":
    "Book a One Way Cab in Shirdi with Sai Shirdi Cabs for a convenient, comfortable, and reliable one-way taxi journey. Our one-way cab service is suitable for local and outstation travel, airport transfers, railway station transfers, Sai Baba Darshan, business trips, family travel, and scheduled drop journeys. Get well-maintained cars, professional drivers, affordable fares, flexible pickup and drop locations, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/one-way-cab-shirdi"
  }
};



    return (
        <div>


<Helmet>
  <title>One Way Cab Shirdi | One Way Taxi Service in Shirdi | +91 7776814559</title>

  <meta
    name="description"
    content="Book a One Way Cab in Shirdi with Sai Shirdi Cabs for comfortable and reliable one-way travel. Get professional drivers, well-maintained cars, affordable fares and easy booking for local and outstation journeys."
  />

  <meta
    name="keywords"
    content="One Way Cab Shirdi, One Way Taxi Shirdi, one way cab service in Shirdi, one way taxi service in Shirdi, Shirdi one way cab booking, Shirdi one way taxi booking, one way cab booking Shirdi, one way taxi booking Shirdi, Shirdi one way cab service, Shirdi one way taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onewaycabshirdi;